import { skipToken, useQuery } from "@tanstack/react-query";

import { apiEcmsHttp } from "@services/http";
import { QUERY_KEYS } from "@services/keys";

import type {
  GetChildEntityBillingAccountBalance,
  GetChildEntityBillingAccountBalanceParams,
} from "./apiEcms.types";

const getChildEntityBillingAccountBalance = async (
  { customerId, contractId }: GetChildEntityBillingAccountBalanceParams,
  signal: AbortSignal,
) => {
  const { data } = await apiEcmsHttp.get<GetChildEntityBillingAccountBalance>(
    `/child-entities/${customerId}/billing-accounts/${contractId}/balance`,
    { signal },
  );

  return data;
};

export const useGetChildEntityBillingAccountBalance = (
  { customerId, contractId }: GetChildEntityBillingAccountBalanceParams,
  enabled: boolean,
) =>
  useQuery({
    queryKey: [QUERY_KEYS.BALANCE, customerId, contractId],
    queryFn: enabled
      ? ({ signal }) =>
          getChildEntityBillingAccountBalance(
            { customerId, contractId },
            signal,
          )
      : skipToken,
    enabled,
  });
